import BaseModelAPI from '../BaseModelAPI';

export default class PartPurchaseQualityControlDetail extends BaseModelAPI {
	static entity = 'partpurchasequalitycontroldetail';
	static entityName = 'partpurchasequalitycontroldetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.controlCardId = '';
			this.controlCard = {};
			this.controlCardControlCardNumber = '';
			this.partPurchaseQualityControlId = '';
			this.partPurchaseQualityControl = {};
			this.thickness = 0;
			this.width = 0;
			this.length = 0;
			this.qty = 0;
			this.karat = false;
			this.retak = false;
			this.goresan = false;
			this.gelombang = false;
			this.burry = false;
			this.benjolan = false;
			this.otherProblem = false;
			this.ngInformation = '';
			this.controlCardStatusId = '';
			this.controlCardStatus = {};
			this.partSpecificationQc = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.isScanned = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}